import { render } from "./manage-direct-debit-activation.vue?vue&type=template&id=b5471dd8"
import script from "./manage-direct-debit-activation.vue?vue&type=script&lang=js"
export * from "./manage-direct-debit-activation.vue?vue&type=script&lang=js"
script.render = render

export default script